import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Snacks naturales para perros',
  desc: 'Recetas fáciles y saludables para premiar a tu perro sin darle alimentos ultraprocesados.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/gwbWk8akxQZRH6Gf2qVyfo/bono1.png'
}, {
  title: 'Guía de suplementos naturales',
  desc: 'Qué suplementos usar, cuándo y en qué cantidad para mejorar su salud.',
  value: '$3.500',
  image: 'https://cdn.magicpatterns.com/uploads/w9hmMRNN6wbDC6kkRReh5N/bono2.png'
}, {
  title: 'Plan de alimentación natural de 30 días',
  desc: 'Un plan listo para aplicar sin tener que pensar qué darle cada día.',
  value: '$4.000',
  image: 'https://cdn.magicpatterns.com/uploads/ftfx9PTPfRX1T3Gj1i2Jec/bono3.png'
}, {
  title: 'Cómo elegir el mejor alimento balanceado',
  desc: 'Aprendé a identificar ingredientes de mala calidad y elegir la mejor opción posible.',
  value: '$2.500',
  image: 'https://cdn.magicpatterns.com/uploads/8AA1STQKKaRtRTNUmJ5A7g/bono4.png'
}, {
  title: 'Soluciones para problemas digestivos',
  desc: 'Qué darle si tu perro tiene diarrea, vómitos o sensibilidad digestiva.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/na5AKTYzAz3zMNBuaDmcdK/bono5.png'
}, {
  title: 'Soluciones para problemas de piel y pelo',
  desc: 'Alimentos y estrategias para mejorar picazón, caída de pelo y alergias.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/i64pZULPXjP3ByCtPGM2X4/bono6.png'
}, {
  title: 'Lista de compras práctica',
  desc: 'Para que sepas exactamente qué comprar y no pierdas tiempo ni dinero.',
  value: '$2.000',
  image: 'https://cdn.magicpatterns.com/uploads/2Z2ScMUciPNiAwHip5RfqE/bono7.png'
}];
export function ValueStack() {
  return <section className="py-20 px-4 bg-cream" data-id="element-266">
      <div className="max-w-5xl mx-auto" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-269">
            Además del ebook principal, hoy te llevás{' '}
            <span className="text-accent" data-id="element-270">7 bonos exclusivos</span>
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-271"></div>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-272">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-sage flex flex-col items-start gap-4 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-273">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-accent" data-id="element-274"></div>

              <div className="flex items-center gap-4 md:gap-6 ml-2" data-id="element-275">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-[140px] object-contain rounded-md flex-shrink-0" data-id="element-276" /> : <div className="w-[140px] h-[140px] rounded-md bg-orange-50 flex items-center justify-center flex-shrink-0 border border-orange-100" data-id="element-277">
                    <span className="text-3xl" data-id="element-278">🎁</span>
                  </div>}
                <div data-id="element-279">
                  <div className="inline-block px-2 py-0.5 bg-accent/10 text-accent text-[11px] font-bold rounded mb-1" data-id="element-280">
                    BONUS {index + 1}
                  </div>
                  <h3 className="text-xl font-bold text-charcoal font-serif leading-snug" data-id="element-281">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 text-sm md:text-base leading-relaxed ml-2" data-id="element-282">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-3 ml-2" data-id="element-283">
                <span className="inline-flex items-center px-2 py-0.5 bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-wider rounded-full" data-id="element-284">
                  🎉 Regalo
                </span>
                <span className="text-gray-400 text-sm font-medium line-through decoration-red-400/70 decoration-2" data-id="element-285">
                  Valor: {bonus.value}
                </span>
                <span className="text-lg font-extrabold text-primary" data-id="element-286">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-primary text-white p-8 rounded-3xl shadow-xl text-center relative overflow-hidden" data-id="element-287">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-288"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full -ml-32 -mb-32 blur-3xl" data-id="element-289"></div>

          <div className="relative z-10" data-id="element-290">
            <p className="text-xl text-white/80 mb-2 font-medium" data-id="element-291">
              Valor total de todo el paquete:
            </p>
            <p className="text-3xl md:text-4xl font-bold line-through text-white/60 mb-4 decoration-red-500/70 decoration-4" data-id="element-292">
              $36.000
            </p>
            <p className="text-xl text-accent font-bold mb-2 uppercase tracking-wider" data-id="element-293">
              Llevate todo hoy por solo:
            </p>
            <p className="text-5xl md:text-7xl font-bold text-white drop-shadow-lg font-serif" data-id="element-294">
              $15.999
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-12 text-center max-w-2xl mx-auto" data-id="element-295">
          <p className="text-xl text-gray-700 font-medium italic" data-id="element-296">
            "No es solo información… Es la tranquilidad de saber que estás
            alimentando bien a tu perro, sin dudas, sin errores y con un sistema
            claro que podés aplicar desde hoy."
          </p>
        </motion.div>
      </div>
    </section>;
}